._separator_18e5c_1._separator_18e5c_1._separator_18e5c_1{grid-column:1 / -1;width:100%;height:1px;margin-block:var(--spacing-4);background-color:var(--default-border-color)}
